import { useStorageIndicatorPreferences } from '@/atoms'
import { selectStorageSpaceData } from '@/features/domain/order'
import { selectUserConfiguration } from '@/features/domain/user'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function useStorageAlert() {
  const { percentage: storagePercentage } = useSelector(selectStorageSpaceData)
  const { planType } = useSelector(selectUserConfiguration)
  const [hideStorageLimitAlert, setHideStorageLimitAlert] = useStorageIndicatorPreferences(
    planType as 'operations' | 'simulation',
  )

  return useMemo(() => {
    // Reset preference if environment is Operations or Simulation and storage < 80%
    if (
      (planType === 'operations' || planType === 'simulation') &&
      storagePercentage < 80 &&
      hideStorageLimitAlert
    ) {
      setHideStorageLimitAlert(false)
    }

    // Determine if component should be visible
    const shouldShow = () => {
      if (planType === 'archived') return false

      // Show warning alerts (80-94%) only if not dismissed
      if (storagePercentage >= 80 && storagePercentage < 95) {
        return !hideStorageLimitAlert
      }

      // Always show critical alerts (95%+)
      if (storagePercentage >= 95) {
        return true
      }

      return false
    }

    return {
      storagePercentage,
      shouldShow: shouldShow(),
      dismissAlert: () => setHideStorageLimitAlert(true),
    }
  }, [storagePercentage, planType, hideStorageLimitAlert, setHideStorageLimitAlert])
}
